// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/component/governance/v1/governance.proto (package penumbra.core.component.governance.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, proto3 } from "@bufbuild/protobuf";
import { Amount } from "../../../num/v1/num_pb.js";
import { SpendAuthSignature, SpendVerificationKey } from "../../../../crypto/decaf377_rdsa/v1/decaf377_rdsa_pb.js";
import { Address, GovernanceKey, IdentityKey } from "../../../keys/v1/keys_pb.js";
import { Value } from "../../../asset/v1/asset_pb.js";
import { Nullifier, SctParameters } from "../../sct/v1/sct_pb.js";
import { Note, NoteView, ShieldedPoolParameters } from "../../shielded_pool/v1/shielded_pool_pb.js";
import { RateData, StakeParameters } from "../../stake/v1/stake_pb.js";
import { CommunityPoolParameters } from "../../community_pool/v1/community_pool_pb.js";
import { IbcParameters } from "../../ibc/v1/ibc_pb.js";
import { FeeParameters } from "../../fee/v1/fee_pb.js";
import { DistributionsParameters } from "../../distributions/v1/distributions_pb.js";
import { FundingParameters } from "../../funding/v1/funding_pb.js";
import { DexParameters } from "../../dex/v1/dex_pb.js";
import { AuctionParameters } from "../../auction/v1/auction_pb.js";

/**
 * A Penumbra ZK delegator vote proof.
 *
 * @generated from message penumbra.core.component.governance.v1.ZKDelegatorVoteProof
 */
export const ZKDelegatorVoteProof = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ZKDelegatorVoteProof",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.ProposalSubmit
 */
export const ProposalSubmit = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalSubmit",
  () => [
    { no: 1, name: "proposal", kind: "message", T: Proposal },
    { no: 3, name: "deposit_amount", kind: "message", T: Amount },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.ProposalWithdraw
 */
export const ProposalWithdraw = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalWithdraw",
  () => [
    { no: 1, name: "proposal", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.ProposalDepositClaim
 */
export const ProposalDepositClaim = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalDepositClaim",
  () => [
    { no: 1, name: "proposal", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "deposit_amount", kind: "message", T: Amount },
    { no: 3, name: "outcome", kind: "message", T: ProposalOutcome },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.ValidatorVote
 */
export const ValidatorVote = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ValidatorVote",
  () => [
    { no: 1, name: "body", kind: "message", T: ValidatorVoteBody },
    { no: 2, name: "auth_sig", kind: "message", T: SpendAuthSignature },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.ValidatorVoteReason
 */
export const ValidatorVoteReason = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ValidatorVoteReason",
  () => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.ValidatorVoteBody
 */
export const ValidatorVoteBody = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ValidatorVoteBody",
  () => [
    { no: 1, name: "proposal", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "vote", kind: "message", T: Vote },
    { no: 3, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 4, name: "governance_key", kind: "message", T: GovernanceKey },
    { no: 5, name: "reason", kind: "message", T: ValidatorVoteReason },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.DelegatorVote
 */
export const DelegatorVote = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.DelegatorVote",
  () => [
    { no: 1, name: "body", kind: "message", T: DelegatorVoteBody },
    { no: 2, name: "auth_sig", kind: "message", T: SpendAuthSignature },
    { no: 3, name: "proof", kind: "message", T: ZKDelegatorVoteProof },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.DelegatorVoteBody
 */
export const DelegatorVoteBody = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.DelegatorVoteBody",
  () => [
    { no: 1, name: "proposal", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "start_position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "vote", kind: "message", T: Vote },
    { no: 4, name: "value", kind: "message", T: Value },
    { no: 5, name: "unbonded_amount", kind: "message", T: Amount },
    { no: 6, name: "nullifier", kind: "message", T: Nullifier },
    { no: 7, name: "rk", kind: "message", T: SpendVerificationKey },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.DelegatorVoteView
 */
export const DelegatorVoteView = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.DelegatorVoteView",
  () => [
    { no: 1, name: "visible", kind: "message", T: DelegatorVoteView_Visible, oneof: "delegator_vote" },
    { no: 2, name: "opaque", kind: "message", T: DelegatorVoteView_Opaque, oneof: "delegator_vote" },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.DelegatorVoteView.Visible
 */
export const DelegatorVoteView_Visible = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.DelegatorVoteView.Visible",
  () => [
    { no: 1, name: "delegator_vote", kind: "message", T: DelegatorVote },
    { no: 2, name: "note", kind: "message", T: NoteView },
  ],
  {localName: "DelegatorVoteView_Visible"},
);

/**
 * @generated from message penumbra.core.component.governance.v1.DelegatorVoteView.Opaque
 */
export const DelegatorVoteView_Opaque = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.DelegatorVoteView.Opaque",
  () => [
    { no: 1, name: "delegator_vote", kind: "message", T: DelegatorVote },
  ],
  {localName: "DelegatorVoteView_Opaque"},
);

/**
 * @generated from message penumbra.core.component.governance.v1.DelegatorVotePlan
 */
export const DelegatorVotePlan = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.DelegatorVotePlan",
  () => [
    { no: 1, name: "proposal", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "start_position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "vote", kind: "message", T: Vote },
    { no: 4, name: "staked_note", kind: "message", T: Note },
    { no: 5, name: "staked_note_position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "unbonded_amount", kind: "message", T: Amount },
    { no: 7, name: "randomizer", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "proof_blinding_r", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 9, name: "proof_blinding_s", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.CommunityPoolDeposit
 */
export const CommunityPoolDeposit = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.CommunityPoolDeposit",
  () => [
    { no: 1, name: "value", kind: "message", T: Value },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.CommunityPoolSpend
 */
export const CommunityPoolSpend = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.CommunityPoolSpend",
  () => [
    { no: 1, name: "value", kind: "message", T: Value },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.CommunityPoolOutput
 */
export const CommunityPoolOutput = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.CommunityPoolOutput",
  () => [
    { no: 1, name: "value", kind: "message", T: Value },
    { no: 2, name: "address", kind: "message", T: Address },
  ],
);

/**
 * A vote on a proposal.
 *
 * @generated from message penumbra.core.component.governance.v1.Vote
 */
export const Vote = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Vote",
  () => [
    { no: 1, name: "vote", kind: "enum", T: proto3.getEnumType(Vote_Vote) },
  ],
);

/**
 * A vote.
 *
 * @generated from enum penumbra.core.component.governance.v1.Vote.Vote
 */
export const Vote_Vote = proto3.makeEnum(
  "penumbra.core.component.governance.v1.Vote.Vote",
  [
    {no: 0, name: "VOTE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "VOTE_ABSTAIN", localName: "ABSTAIN"},
    {no: 2, name: "VOTE_YES", localName: "YES"},
    {no: 3, name: "VOTE_NO", localName: "NO"},
  ],
);

/**
 * The current state of a proposal.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalState
 */
export const ProposalState = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalState",
  () => [
    { no: 2, name: "voting", kind: "message", T: ProposalState_Voting, oneof: "state" },
    { no: 3, name: "withdrawn", kind: "message", T: ProposalState_Withdrawn, oneof: "state" },
    { no: 4, name: "finished", kind: "message", T: ProposalState_Finished, oneof: "state" },
    { no: 5, name: "claimed", kind: "message", T: ProposalState_Claimed, oneof: "state" },
  ],
);

/**
 * Voting is in progress and the proposal has not yet concluded voting or been withdrawn.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalState.Voting
 */
export const ProposalState_Voting = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalState.Voting",
  [],
  {localName: "ProposalState_Voting"},
);

/**
 * The proposal has been withdrawn but the voting period is not yet concluded.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalState.Withdrawn
 */
export const ProposalState_Withdrawn = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalState.Withdrawn",
  () => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "ProposalState_Withdrawn"},
);

/**
 * The voting period has ended, and the proposal has been assigned an outcome.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalState.Finished
 */
export const ProposalState_Finished = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalState.Finished",
  () => [
    { no: 1, name: "outcome", kind: "message", T: ProposalOutcome },
  ],
  {localName: "ProposalState_Finished"},
);

/**
 * The voting period has ended, and the original proposer has claimed their deposit.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalState.Claimed
 */
export const ProposalState_Claimed = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalState.Claimed",
  () => [
    { no: 1, name: "outcome", kind: "message", T: ProposalOutcome },
  ],
  {localName: "ProposalState_Claimed"},
);

/**
 * The outcome of a concluded proposal.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalOutcome
 */
export const ProposalOutcome = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalOutcome",
  () => [
    { no: 1, name: "passed", kind: "message", T: ProposalOutcome_Passed, oneof: "outcome" },
    { no: 2, name: "failed", kind: "message", T: ProposalOutcome_Failed, oneof: "outcome" },
    { no: 3, name: "slashed", kind: "message", T: ProposalOutcome_Slashed, oneof: "outcome" },
  ],
);

/**
 * Whether or not the proposal was withdrawn.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalOutcome.Withdrawn
 */
export const ProposalOutcome_Withdrawn = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalOutcome.Withdrawn",
  () => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "ProposalOutcome_Withdrawn"},
);

/**
 * The proposal was passed.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalOutcome.Passed
 */
export const ProposalOutcome_Passed = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalOutcome.Passed",
  [],
  {localName: "ProposalOutcome_Passed"},
);

/**
 * The proposal did not pass.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalOutcome.Failed
 */
export const ProposalOutcome_Failed = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalOutcome.Failed",
  () => [
    { no: 1, name: "withdrawn", kind: "message", T: ProposalOutcome_Withdrawn },
  ],
  {localName: "ProposalOutcome_Failed"},
);

/**
 * The proposal did not pass, and was slashed.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalOutcome.Slashed
 */
export const ProposalOutcome_Slashed = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalOutcome.Slashed",
  () => [
    { no: 1, name: "withdrawn", kind: "message", T: ProposalOutcome_Withdrawn },
  ],
  {localName: "ProposalOutcome_Slashed"},
);

/**
 * A tally of votes on a proposal.
 *
 * @generated from message penumbra.core.component.governance.v1.Tally
 */
export const Tally = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Tally",
  () => [
    { no: 1, name: "yes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "no", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "abstain", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * A proposal to be voted upon.
 *
 * @generated from message penumbra.core.component.governance.v1.Proposal
 */
export const Proposal = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Proposal",
  () => [
    { no: 4, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "signaling", kind: "message", T: Proposal_Signaling, oneof: "payload" },
    { no: 6, name: "emergency", kind: "message", T: Proposal_Emergency, oneof: "payload" },
    { no: 7, name: "parameter_change", kind: "message", T: Proposal_ParameterChange, oneof: "payload" },
    { no: 8, name: "community_pool_spend", kind: "message", T: Proposal_CommunityPoolSpend, oneof: "payload" },
    { no: 9, name: "upgrade_plan", kind: "message", T: Proposal_UpgradePlan, oneof: "payload" },
    { no: 10, name: "freeze_ibc_client", kind: "message", T: Proposal_FreezeIbcClient, oneof: "payload" },
    { no: 11, name: "unfreeze_ibc_client", kind: "message", T: Proposal_UnfreezeIbcClient, oneof: "payload" },
  ],
);

/**
 * A signaling proposal is meant to register a vote on-chain, but does not have an automatic
 * effect when passed.
 *
 * It optionally contains a reference to a commit which contains code to upgrade the chain.
 *
 * @generated from message penumbra.core.component.governance.v1.Proposal.Signaling
 */
export const Proposal_Signaling = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Proposal.Signaling",
  () => [
    { no: 1, name: "commit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Proposal_Signaling"},
);

/**
 * An emergency proposal can be passed instantaneously by a 1/3 majority of validators, without
 * waiting for the voting period to expire.
 *
 * If the boolean `halt_chain` is set to `true`, then the chain will halt immediately when the
 * proposal is passed.
 *
 * @generated from message penumbra.core.component.governance.v1.Proposal.Emergency
 */
export const Proposal_Emergency = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Proposal.Emergency",
  () => [
    { no: 1, name: "halt_chain", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "Proposal_Emergency"},
);

/**
 * A parameter change proposal describes a replacement of the app parameters, which should take
 * effect when the proposal is passed.
 *
 * @generated from message penumbra.core.component.governance.v1.Proposal.ParameterChange
 */
export const Proposal_ParameterChange = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Proposal.ParameterChange",
  () => [
    { no: 1, name: "old_parameters", kind: "message", T: ChangedAppParameters },
    { no: 2, name: "new_parameters", kind: "message", T: ChangedAppParameters },
    { no: 3, name: "preconditions", kind: "message", T: EncodedParameter, repeated: true },
    { no: 4, name: "changes", kind: "message", T: EncodedParameter, repeated: true },
  ],
  {localName: "Proposal_ParameterChange"},
);

/**
 * A Community Pool spend proposal describes zero or more transactions to execute on behalf of the Community Pool, with
 * access to its funds, and zero or more scheduled transactions from previous passed proposals to
 * cancel.
 *
 * @generated from message penumbra.core.component.governance.v1.Proposal.CommunityPoolSpend
 */
export const Proposal_CommunityPoolSpend = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Proposal.CommunityPoolSpend",
  () => [
    { no: 2, name: "transaction_plan", kind: "message", T: Any },
  ],
  {localName: "Proposal_CommunityPoolSpend"},
);

/**
 * An upgrade plan describes a candidate upgrade to be executed at a certain height. If passed, the chain
 * will halt at the specified height.
 *
 * @generated from message penumbra.core.component.governance.v1.Proposal.UpgradePlan
 */
export const Proposal_UpgradePlan = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Proposal.UpgradePlan",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
  {localName: "Proposal_UpgradePlan"},
);

/**
 * Freeze an existing IBC client.
 * Like `Emergency` proposals, it is enacted immediately after receiving
 * +2/3 of validator votes.
 *
 * @generated from message penumbra.core.component.governance.v1.Proposal.FreezeIbcClient
 */
export const Proposal_FreezeIbcClient = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Proposal.FreezeIbcClient",
  () => [
    { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Proposal_FreezeIbcClient"},
);

/**
 * Unfreeze an existing IBC client.
 * Like `Emergency` proposals, it is enacted immediately after receiving
 * +2/3 of validator votes.
 *
 * @generated from message penumbra.core.component.governance.v1.Proposal.UnfreezeIbcClient
 */
export const Proposal_UnfreezeIbcClient = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Proposal.UnfreezeIbcClient",
  () => [
    { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Proposal_UnfreezeIbcClient"},
);

/**
 * @generated from message penumbra.core.component.governance.v1.ProposalInfoRequest
 */
export const ProposalInfoRequest = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalInfoRequest",
  () => [
    { no: 2, name: "proposal_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.ProposalInfoResponse
 */
export const ProposalInfoResponse = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalInfoResponse",
  () => [
    { no: 1, name: "start_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "start_position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.ProposalDataRequest
 */
export const ProposalDataRequest = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalDataRequest",
  () => [
    { no: 2, name: "proposal_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.ProposalDataResponse
 */
export const ProposalDataResponse = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalDataResponse",
  () => [
    { no: 1, name: "proposal", kind: "message", T: Proposal },
    { no: 2, name: "start_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "end_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "start_position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "state", kind: "message", T: ProposalState },
    { no: 6, name: "proposal_deposit_amount", kind: "message", T: Amount },
  ],
);

/**
 * Requests the validator rate data for a proposal.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalRateDataRequest
 */
export const ProposalRateDataRequest = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalRateDataRequest",
  () => [
    { no: 2, name: "proposal_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * The rate data for a single validator.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalRateDataResponse
 */
export const ProposalRateDataResponse = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalRateDataResponse",
  () => [
    { no: 1, name: "rate_data", kind: "message", T: RateData },
  ],
);

/**
 * Requests the list of all proposals.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalListRequest
 */
export const ProposalListRequest = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalListRequest",
  () => [
    { no: 2, name: "inactive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * The data for a single proposal.
 *
 * @generated from message penumbra.core.component.governance.v1.ProposalListResponse
 */
export const ProposalListResponse = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ProposalListResponse",
  () => [
    { no: 1, name: "proposal", kind: "message", T: Proposal },
    { no: 2, name: "start_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "end_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "start_position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "state", kind: "message", T: ProposalState },
  ],
);

/**
 * Requests the list of all validator votes for a given proposal.
 *
 * @generated from message penumbra.core.component.governance.v1.ValidatorVotesRequest
 */
export const ValidatorVotesRequest = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ValidatorVotesRequest",
  () => [
    { no: 2, name: "proposal_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * The data for a single validator vote.
 *
 * @generated from message penumbra.core.component.governance.v1.ValidatorVotesResponse
 */
export const ValidatorVotesResponse = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ValidatorVotesResponse",
  () => [
    { no: 1, name: "vote", kind: "message", T: Vote },
    { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
  ],
);

/**
 * Governance configuration data.
 *
 * @generated from message penumbra.core.component.governance.v1.GovernanceParameters
 */
export const GovernanceParameters = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.GovernanceParameters",
  () => [
    { no: 1, name: "proposal_voting_blocks", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "proposal_deposit_amount", kind: "message", T: Amount },
    { no: 3, name: "proposal_valid_quorum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "proposal_pass_threshold", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "proposal_slash_threshold", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Governance genesis state.
 *
 * @generated from message penumbra.core.component.governance.v1.GenesisContent
 */
export const GenesisContent = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.GenesisContent",
  () => [
    { no: 1, name: "governance_params", kind: "message", T: GovernanceParameters },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.EncodedParameter
 */
export const EncodedParameter = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.EncodedParameter",
  () => [
    { no: 1, name: "component", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * DEPRECATED
 *
 * @generated from message penumbra.core.component.governance.v1.ChangedAppParameters
 * @deprecated
 */
export const ChangedAppParameters = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ChangedAppParameters",
  () => [
    { no: 1, name: "sct_params", kind: "message", T: SctParameters },
    { no: 2, name: "community_pool_params", kind: "message", T: CommunityPoolParameters },
    { no: 3, name: "governance_params", kind: "message", T: GovernanceParameters },
    { no: 4, name: "ibc_params", kind: "message", T: IbcParameters },
    { no: 5, name: "stake_params", kind: "message", T: StakeParameters },
    { no: 6, name: "fee_params", kind: "message", T: FeeParameters },
    { no: 7, name: "distributions_params", kind: "message", T: DistributionsParameters },
    { no: 8, name: "funding_params", kind: "message", T: FundingParameters },
    { no: 9, name: "shielded_pool_params", kind: "message", T: ShieldedPoolParameters },
    { no: 10, name: "dex_params", kind: "message", T: DexParameters },
    { no: 11, name: "auction_params", kind: "message", T: AuctionParameters },
  ],
);

/**
 * DEPRECATED
 *
 * @generated from message penumbra.core.component.governance.v1.ChangedAppParametersSet
 * @deprecated
 */
export const ChangedAppParametersSet = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.ChangedAppParametersSet",
  () => [
    { no: 1, name: "old", kind: "message", T: ChangedAppParameters },
    { no: 2, name: "new", kind: "message", T: ChangedAppParameters },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.VotingPowerAtProposalStartRequest
 */
export const VotingPowerAtProposalStartRequest = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.VotingPowerAtProposalStartRequest",
  () => [
    { no: 2, name: "proposal_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "identity_key", kind: "message", T: IdentityKey },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.VotingPowerAtProposalStartResponse
 */
export const VotingPowerAtProposalStartResponse = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.VotingPowerAtProposalStartResponse",
  () => [
    { no: 1, name: "voting_power", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.AllTalliedDelegatorVotesForProposalRequest
 */
export const AllTalliedDelegatorVotesForProposalRequest = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.AllTalliedDelegatorVotesForProposalRequest",
  () => [
    { no: 2, name: "proposal_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.AllTalliedDelegatorVotesForProposalResponse
 */
export const AllTalliedDelegatorVotesForProposalResponse = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.AllTalliedDelegatorVotesForProposalResponse",
  () => [
    { no: 1, name: "tally", kind: "message", T: Tally },
    { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.NextProposalIdRequest
 */
export const NextProposalIdRequest = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.NextProposalIdRequest",
  [],
);

/**
 * @generated from message penumbra.core.component.governance.v1.NextProposalIdResponse
 */
export const NextProposalIdResponse = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.NextProposalIdResponse",
  () => [
    { no: 1, name: "next_proposal_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * The ratio between two numbers, used in governance to describe vote thresholds and quorums.
 *
 * @generated from message penumbra.core.component.governance.v1.Ratio
 */
export const Ratio = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.Ratio",
  () => [
    { no: 1, name: "numerator", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "denominator", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.EventDelegatorVote
 */
export const EventDelegatorVote = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.EventDelegatorVote",
  () => [
    { no: 1, name: "vote", kind: "message", T: DelegatorVote },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.EventProposalDepositClaim
 */
export const EventProposalDepositClaim = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.EventProposalDepositClaim",
  () => [
    { no: 1, name: "deposit_claim", kind: "message", T: ProposalDepositClaim },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.EventValidatorVote
 */
export const EventValidatorVote = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.EventValidatorVote",
  () => [
    { no: 1, name: "vote", kind: "message", T: ValidatorVote },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.EventProposalWithdraw
 */
export const EventProposalWithdraw = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.EventProposalWithdraw",
  () => [
    { no: 1, name: "withdraw", kind: "message", T: ProposalWithdraw },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.EventProposalSubmit
 */
export const EventProposalSubmit = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.EventProposalSubmit",
  () => [
    { no: 1, name: "submit", kind: "message", T: ProposalSubmit },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.EventEnactProposal
 */
export const EventEnactProposal = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.EventEnactProposal",
  () => [
    { no: 1, name: "proposal", kind: "message", T: Proposal },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.EventProposalFailed
 */
export const EventProposalFailed = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.EventProposalFailed",
  () => [
    { no: 1, name: "proposal", kind: "message", T: Proposal },
  ],
);

/**
 * @generated from message penumbra.core.component.governance.v1.EventProposalSlashed
 */
export const EventProposalSlashed = proto3.makeMessageType(
  "penumbra.core.component.governance.v1.EventProposalSlashed",
  () => [
    { no: 1, name: "proposal", kind: "message", T: Proposal },
  ],
);

